export const LOCKED_DESCRIPTION = 'Locked: Premium Only'
